import Head from 'next/head';
import Link from 'next/link';

import { GLFHApplicationProcessHelpSEO } from '@/utils/constants/MetaData';

const GoldLoanfromHomeApplicationProcess = () => {
  return (
    <>
      <Head>
        <title>{GLFHApplicationProcessHelpSEO.metaTitle}</title>
        <meta
          name="description"
          content={GLFHApplicationProcessHelpSEO.metaDescription}
        />
        <meta
          property="og:description"
          content={GLFHApplicationProcessHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/gold-loans/gold-loan-from-home-application-process/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">Gold Loan Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Gold Loan from Home Application Process
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Gold Loan from Home Application Process
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How can I apply for a Gold Loan from Home?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can book an appointment for a Gold Loan from Home
                    through our app or by visiting our website
                    <Link href="/"> www.muthootfincorpone.com</Link> or through
                    WhatsApp: 9633740733. Once an appointment is scheduled our
                    representatives will be in touch within 24-48 hrs for the
                    next steps.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What documents do I need to get a Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    To get a Gold Loan from Home you need to share the following
                    documents to get started with your Gold Loan application:
                    <br />
                    - ID Proof: Aadhaar Card, Voters ID, or Driving License
                    <br />
                    - Address Proof: Aadhaar Card, Voter ID, Driving License, or
                    Utility Bill (Phone/Gas/Electricity/Water/Broadband, etc.)
                    <br />- PAN Card or Form 60
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  Do I need a bank account to get a Gold Loan from Home?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, you must have an active bank account to get a Gold Loan
                    from Home. The loan amount is transferred directly to the
                    bank account shared with us.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  What are the steps for approval to get a Gold Loan from Home ?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Upon booking the appointment, our Loan Manager will visit
                    your home at the agreed time. These are the steps to get a
                    Gold Loan from Home
                    <br />
                    a.Evaluation of your Gold jewellery
                    <br />
                    b.Your KYC verification
                    <br />
                    c.Electronic submission of your documents
                    <br />
                    The Loan Manager will guide you through these steps and
                    ensure the amount is credited to your bank account before
                    closing your appointment for our Gold Loan from Home.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  How is my gold assessed/evaluated?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Our Loan Manager will weigh each of the gold ornaments and
                    enter the price and weight of these ornaments in our system.
                    The purity of your gold ornaments is assessed through
                    industry-approved tests. The entire process takes place at
                    your home to maintain transparency.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  Can I extend my loan tenure?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    We currently do not offer the option to extend your loan
                    tenure through our app. However, you can head to a Muthoot
                    FinCorp branch near you for more information about the
                    renewal of a gold loan or the re-pledge process.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  Can I withdraw a part of the gold that I have pledged?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    We currently do not offer a partial release of your pledged
                    gold ornaments through our app. However, you can head to a
                    Muthoot FinCorp branch near you to know more.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default GoldLoanfromHomeApplicationProcess;
